import { V3Record } from "data/helpers/V3Record.js";

export const PointOfInterest = V3Record("pointOfInterest", {
  id: null,
  lat: null,
  lng: null,
  name: null,
  description: null,
  photoIds: [],
  poiType: null,
  url: null,
  userId: null,
  visibility: null,
});
